// src/components/Navbar.js

import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/Logo.svg'; // Import SVG as React Component

function Navbar() {
  const toggleMobileMenu = () => {
	const menu = document.getElementById('mobile-menu');
	if (menu) {
	  menu.classList.toggle('hidden');
	}
  };

  return (
	<nav className="sticky-nav bg-white bg-opacity-90">
	  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
		{/* Desktop Navigation */}
		<div className="flex justify-between h-16">
		  {/* Logo */}
		  <div className="flex items-center">
			<Link to="/" className="flex items-center">
			  <Logo className="h-8 w-40" aria-hidden="true" />
			  {/* Removed the text "GlassHaus" */}
			</Link>
		  </div>

		  {/* Mobile Menu Button (hidden on desktop) */}
		  <div className="md:hidden flex items-center">
			<button
			  onClick={toggleMobileMenu}
			  className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
			  aria-label="Toggle menu" // Added for accessibility
			>
			  <span className="sr-only">Open menu</span>
			  {/* Hamburger icon */}
			  <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
				<path
				  strokeLinecap="round"
				  strokeLinejoin="round"
				  strokeWidth="2"
				  d="M4 6h16M4 12h16M4 18h16"
				/>
			  </svg>
			</button>
		  </div>
		</div>
	  </div>

	  {/* Mobile Menu (hidden by default) */}
	  <div id="mobile-menu" className="hidden md:hidden bg-white shadow-lg absolute w-full z-50">
		{/* Removed menu links */}
	  </div>
	</nav>
  );
}

export default Navbar;
